import React, { FC } from 'react';

import { Text, Flex, Heading } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { MdArrowBack } from 'react-icons/md';

import SiteForm from 'components/modules/SiteForm';

import { UserPill } from 'components/core/UserPill';

import { CreateSiteViewProps } from './CreateSite.props';

const CreateSiteView: FC<CreateSiteViewProps> = ({
  siteId,
  isLoading,
  onSubmit,
}) => {
  const navigate = useNavigate();
  return (
    <Flex flex={1} direction="column">
      <Flex p="20px 40px" shadow="lg" justify="space-between">
        <Flex gap="20px" align="center">
          <button onClick={() => navigate(-1)}>
            <MdArrowBack size="26px" />
          </button>
          <Heading fontSize="24px" fontWeight="600">
            Create new site
          </Heading>
        </Flex>

        <UserPill />
      </Flex>

      <Flex
        flex={1}
        direction="column"
        p="40px"
        maxW="1400px"
        alignSelf="center"
        w="100%">
        <SiteForm
          site={null}
          siteId={siteId}
          isLoading={isLoading}
          isReadOnly={false}
          onSubmit={onSubmit}
        />
      </Flex>
    </Flex>
  );
};

export default CreateSiteView;
